import React from "react";
import Error from "../../modals/SharedModal/Error";
import s from "./ErrorBoundary.module.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
    //logToSentry(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={s.container}>
          <Error />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
